import { Table } from "components";
import { useEffect } from "react";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { connect } from "react-redux";
import { TableColumns } from "./components/TableColumns";
import { fetchEmailLogs } from "../store/action";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const EmailLogsTable: React.FC<Props> = ({
  fetchEmailLogs,
  onFetchEmailLogs,
}) => {
  const emailLogsData = fetchEmailLogs?.emailLogs;
  useEffect(() => {
    onFetchEmailLogs();
  }, [onFetchEmailLogs]);
  const downloadExcel = (data: any[]) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((field) => `<td>${row[field] ?? ""}</td>`)
            .join("")}</tr>`
      )
      .join("");

    const tableHTML = `
    <table>
      <thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>
      <tbody>${rows}</tbody>
    </table>`;

    const blob = new Blob(
      [
        `\uFEFF<html><head><meta charset="UTF-8"></head><body>${tableHTML}</body></html>`,
      ],
      { type: "application/vnd.ms-excel" }
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "email_logs.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Table
        headers={["Report", "Email Logs"]}
        data={emailLogsData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <div>
            <button
              className="border px-3 py-2 bg-primary-500 mx-2 rounded-md hover:bg-primary-800 text-primary-100 hover:text-white hover:shadow-md"
              onClick={() => downloadExcel(emailLogsData)}
            >
              Download Excel
            </button>
          </div>
        }
      />
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchEmailLogs: state.email.fetchEmailLogsState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchEmailLogs: () => dispatch(fetchEmailLogs()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailLogsTable);
